module.exports = __webpack_public_path__ + "img/mcgl_xsbj_03.0fe56186.png";